import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatSnackBar } from '@angular/material';
import { ExerciseService } from 'app/shared/services/exercises.service';
import { Program } from '../../../shared/models/Program';
import { MpDialogComponent } from '../mp-dialog/mp-dialog.component';
import { Exercise } from '../../../shared/models/Exercises';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-add-dialog',
  templateUrl: './add-dialog.component.html',
  styleUrls: ['./add-dialog.component.scss'],
})
export class AddDialogComponent {
  @Input() addExercise: Exercise;
  @Input() title: string;
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  public favs: Program[];
  newProgramTitle: string = '';

  constructor(
    private exerciseService: ExerciseService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    public dialogRef: MatDialogRef<AddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data && data.exerciseID) {
      this.addExercise = data.exerciseID;
    }

    this.exerciseService.getMyPrograms().then((programs) => {
      this.favs = programs.filter((prog) => {
        return prog.exerciseIds.length < 3 && !prog.exercises.includes(this.addExercise);
      });
      translate
        .get('EXERCISES.EDITOR.defaultProgramTitle', { number: this.favs.length + 1 })
        .subscribe((res: string) => {
          this.newProgramTitle = res;
        });
    });
  }

  closeAddDialog(): void {
    this.onSelect.emit();
    this.closeDialog();
  }

  closeDialog(result?: any): void {
    this.dialogRef.close(result);
  }

  openMpDialog(editProgram: Program) {
    const dialogRef = this.dialog.open(MpDialogComponent, {
      panelClass: 'app-MP-dialog-container',
      // width: '90vw',
      // height: '98vh',
      position: {
        top: '2vh',
      },
      data: editProgram || {},
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  addToProgram(editProgram?: Program) {
    if (editProgram) {
      editProgram.exerciseIds.push(this.addExercise._id);
      editProgram.exercises.push(this.addExercise);

      this.exerciseService
        .updateMyProgram(editProgram)
        .then((result) => {
          this.translate.get('EXERCISES.EDITOR.ALERT.addedToProgram', editProgram).subscribe((message: string) => {
            const snackBarRef = this.snackBar.open(message, null, {
              verticalPosition: 'top',
              duration: 4000,
              panelClass: ['b2a-success', 'top'],
            });
            this.closeAddDialog();
          });
        })
        .catch((error) => {
          this.translate.get('EXERCISES.EDITOR.ALERT.addToProgramError', editProgram).subscribe((message: string) => {
            const snackBarRef = this.snackBar.open(message, null, {
              verticalPosition: 'top',
              duration: 4000,
              panelClass: ['b2a-error', 'top'],
            });
          });
        });
    } else {
      editProgram = new Program();

      editProgram.exerciseIds = [this.addExercise._id];
      editProgram.exercises = [this.addExercise];

      editProgram.title = this.newProgramTitle;
      editProgram.previewUrl = this.addExercise.previewUrl;

      this.exerciseService
        .saveNewProgram(editProgram)
        .then((result) => {
          this.translate.get('EXERCISES.EDITOR.ALERT.addedToNewProgram', editProgram).subscribe((message: string) => {
            const snackBarRef = this.snackBar.open(message, null, {
              verticalPosition: 'top',
              duration: 4000,
              panelClass: ['b2a-success', 'top'],
            });
            this.closeAddDialog();
          });
        })
        .catch((error) => {
          this.translate.get('EXERCISES.EDITOR.ALERT.addToProgramError', editProgram).subscribe((message: string) => {
            const snackBarRef = this.snackBar.open(message, null, {
              verticalPosition: 'top',
              duration: 4000,
              panelClass: ['b2a-error', 'top'],
            });
          });
        });
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/add-dialog/add-dialog.component.ts